// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ci-a";
export var fulfillmentFormRail = "_ci-9";
export var headerTitleRow = "_ci-c";
export var orderDetailsWrapper = "_ci-7";
export var orderLinkTrigger = "_ci-2";
export var paymentInformationGrid = "_ci-h";
export var paymentSummaryColumn = "_ci-i";
export var shipmentContainer = "_ci-b";
export var shipmentDetailsMainPane = "_ci-8";
export var shipmentNavigationCard = "_ci-5";
export var shipmentNavigationRail = "_ci-3";
export var shipmentNavigationRailHeader = "_ci-4";
export var shipmentSummaryFact = "_ci-e";
export var shipmentSummaryGrid = "_ci-d";
export var shipmentSummaryMetadataRow = "_ci-f";
export var shipmentSummaryTags = "_ci-g";
export var shipmentWorkspace = "_ci-0";
export var shipmentWorkspaceContent = "_ci-6";
export var shipmentWorkspaceHeader = "_ci-1";